<template>
  <v-dialog value="value" max-width="290" persistent>
    <v-card class="pb-4">
      <v-card-title style="background-color: #004056" class="white--text">
        Referral sent!
      </v-card-title>

      <v-divider />

      <v-card-text class="mt-3">
        <div>
          <strong>Please remind</strong> your customer that they will be contacted
          by up to four pros over the next few days.
        </div>
        <div class="mt-3">
          Your customer will need to choose a pro and coordinate with them to
          schedule the work.
        </div>

        <div class="mt-3">
          The customer's contact information is <strong>only used</strong> connect them with the up to four pros who claim the lead.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          width="60%"
          @click="okClick"
        >
          ok
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ReferralConfirmationDialog',

  props: ['value'],

  methods: {
    okClick() {
      this.$emit('input', false),
      this.$emit('done')
    },
  },
}

</script>